<template>
  <tr>
    <td>
      <b-form-datepicker v-model="tasaEditada.fechaInicio" v-show="editando" />
      <span v-show="!editando">{{ dateFormat(tasa.fechaInicio) }} </span>
    </td>
    <td>
      <b-form-datepicker v-model="tasaEditada.fechaFin" v-show="editando" />
      <span v-show="!editando">{{ dateFormat(tasa.fechaFin) }} </span>
    </td>
    <td>
      <b-form-input type="number" v-model="tasaEditada.tasaConversion" v-show="editando" @keypress.enter="guardar" />
      <span v-show="!editando">{{ tasa.tasaConversion }} </span>
    </td>
    <td nowrap>
      <b-button variant="primary" size="sm" @click="editar" v-show="!editando">
        <v-icon name="edit" width="16" /> Editar
      </b-button>

      <b-button-group v-show="editando">
        <b-button variant="secondary" size="sm" @click="cancelar"> <v-icon name="x" width="16" /> Cancelar </b-button>
        <b-button variant="success" size="sm" @click="guardar"> <v-icon name="check" width="16" /> Guardar </b-button>
      </b-button-group>

      <span v-show="!editando">
        |
        <b-button variant="danger" size="sm" @click="eliminar" v-show="!editando">
          <v-icon name="trash" width="16" /> Eliminar
        </b-button>
      </span>
    </td>
  </tr>
</template>

<script>
import { formatDateEs } from "@/services/date.js";
import { useDivisaStore } from "@/stores/DivisaStore";

export default {
  props: {
    tasa: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tasaEditada: {
        id: this.tasa.id,
        divisaId: this.tasa.divisaId,
        fechaInicio: this.tasa.fechaInicio,
        fechaFin: this.tasa.fechaFin,
        tasaConversion: this.tasa.tasaConversion,
      },
      editando: false,
    };
  },
  methods: {
    editar() {
      this.tasaEditada = {
        id: this.tasa.id,
        divisaId: this.tasa.divisaId,
        fechaInicio: this.tasa.fechaInicio,
        fechaFin: this.tasa.fechaFin,
        tasaConversion: this.tasa.tasaConversion,
      };
      this.editando = true;
    },
    async eliminar() {
      const ok = await this.$messages.confirm("¿Desea eliminar esta tasa?");
      if (ok) {
        const store = useDivisaStore();
        await store.eliminarTasa(this.tasa.id);
        this.$messages.info("Tasa eliminada");
      }
    },
    async guardar() {
      const store = useDivisaStore();
      await store.guardarTasa(this.tasaEditada);
      this.$messages.success("Tasa guardada");
      this.editando = false;
    },
    cancelar() {
      this.editando = false;
    },
    dateFormat: formatDateEs,
  },
};
</script>
